export const getCollection = (state) => state.collections.collectionItem;
export const getCollectionsStateList = (state) => state.collections.list;
export const getCollectionLoadError = (state) => state.collections.collectionLoadError;
